import { render, staticRenderFns } from "./viewWorkDig.vue?vue&type=template&id=1e4bb3a8&"
import script from "./viewWorkDig.vue?vue&type=script&lang=js&"
export * from "./viewWorkDig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports